import React from "react";
import { Modal } from "react-bootstrap";
import { IoClose } from 'react-icons/io5'
export default function ShowImageModal(props) {

    const handleClose = () => {
        props?.onClose();
    }
    return (<>
        <div>

            <Modal show={props.show} onHide={handleClose} centered size="xl">

                <Modal.Body >
                    <div className="justify-content-center align-items-center  position-relative d-flex row  " >

                        <IoClose size={30} className="text-danger position-absolute end-0 top-0 w-auto bg-light " onClick={handleClose} />
                        <img
                            src={props?.src}
                            alt="new"
                            style={{ minHeight: `${window.innerHeight / 5 * 4}px`, width: 'auto' }}
                        />



                    </div>

                </Modal.Body>

            </Modal>


        </div>

    </>)
}
